@for (market of event.markets; track trackById($index, event)) {
    @if (isSportCard(market) && (!widget || eventDisplayed(market)) && !market.hidden) {
        <div
            class="odds-card sticky-virtual-scroll-item"
            style="content-visibility: auto; contain-intrinsic-height: auto 88px"
            (click)="goToEvent(false, $event); goToSeo(); gaTracking()"
            [attr.data-eventid]="event.id"
            [ngClass]="{ 'coupon-odds-card': isFootballCoupon && event.isShowStatsEnabled }"
            data-crlat="oddsCard.sportTemplate">
            <div class="odds-content" [ngClass]="{ 'odds-wrap': widget }" data-crlat="oddsContent">
                <div class="odds-left" data-crlat="oddsLeft">
                    <!-- One name template -->
                    @if (event.outcomeStatus || !eventSecondName) {
                        <div class="odds-names" [ngClass]="{ 'odds-names-wrap': !isOddsSports }" data-crlat="oddsNames">
                            <b [textContent]="eventName" data-crlat="singleEventName"></b>
                        </div>
                    }
                    @if (!event.outcomeStatus) {
                        <!-- Two teams template -->
                        @if (eventSecondName && !eventThirdName) {
                            <div class="odds-names odds-names-list" data-crlat="oddsNames">
                                <div class="odds-name-row">
                                    <b [textContent]="eventFirstName" data-crlat="EventFirstName"></b>
                                    @if (isFootball && event?.aggregateScore?.home) {
                                        <span class="agg-score" [textContent]="'(' + event.aggregateScore.home + ')'"></span>
                                    }
                                    @if (servingTeams[0]) {
                                        <span class="odds-serve" data-crlat="bIcon"></span>
                                    }
                                </div>
                                <div class="odds-name-row">
                                    <b [textContent]="eventSecondName" data-crlat="EventSecondName"></b>
                                    @if (isFootball && event?.aggregateScore?.away) {
                                        <span class="agg-score" [textContent]="'(' + event.aggregateScore.away + ')'"></span>
                                    }
                                    @if (servingTeams[1]) {
                                        <span class="odds-serve" data-crlat="bIcon"></span>
                                    }
                                </div>
                            </div>
                        }
                        <!-- Three teams template -->
                        @if (eventThirdName) {
                            <div class="odds-names odds-names-list" data-crlat="oddsNames">
                                <div class="odds-name-row">
                                    <b [textContent]="eventFirstName" data-crlat="EventFirstName"></b>
                                    @if (servingTeams[0]) {
                                        <span class="odds-serve" data-crlat="bIcon"></span>
                                    }
                                </div>
                                <div class="odds-name-row">
                                    <b [textContent]="eventSecondName" data-crlat="EventSecondName"></b>
                                    @if (servingTeams[1]) {
                                        <span class="odds-serve" data-crlat="bIcon"></span>
                                    }
                                </div>
                                <div class="odds-name-row">
                                    <b [textContent]="eventThirdName" data-crlat="EventThirdName"></b>
                                </div>
                            </div>
                        }
                    }
                </div>
                <div class="odds-right" data-crlat="oddsRight">
                    @if (statsUpdate()) {
                        <lazy-component
                            moduleUri="@lazy-modules-module/oddsCardStatsModule/odds-card-stats.module#OddsCardStatsModule"
                            [inputs]="{
                                event: event,
                                statsDisplayData: event.scoreBoardStats,
                                statsDisplayFilter: statsFilter,
                                changeStrategy: 'onPush',
                                oddsScoresData: oddsScoresData,
                            }"
                            data-crlat="OddsCardStatsModule">
                        </lazy-component>
                    }
                    <div class="odds-score-coral-mobile-container">
                        @if (oddsScoresData) {
                            <odds-card-score
                                [boxScore]="boxScore"
                                [isCoralMobile]="isCoralMobile"
                                [score]="oddsScoresData"
                                [scoreHeaders]="scoreHeaders"
                                [isIP]="isIP"
                                [isHP]="isHP"></odds-card-score>
                        }
                    </div>
                    <!-- Sport Odds Buttons -->
                    @if (isOddsSports && selectedMarketObject.outcomes.length) {
                        <div class="odds-btn-content" data-crlat="oddsBtnContent" (click)="$event.stopPropagation()">
                            @for (outcomeEntity of correctedOutcomes; track trackByOutcomes(i, outcomeEntity); let i = $index) {
                                <div>
                                    @if (showTemplate(i)) {
                                        <div class="odds-btn-wrapper" data-crlat="oddsBtnWrapper">
                                            @if (outcomeEntity) {
                                                <price-odds-button
                                                    id="bet-{{ outcomeEntity.id }}"
                                                    data-crlat="betButton"
                                                    [event]="event"
                                                    [market]="selectedMarketObject"
                                                    [outcome]="outcomeEntity"
                                                    [gtmModuleTitle]="gtmModuleTitle"
                                                    class="price-odds-button"
                                                    (click)="onPriceOddsButtonClick($event, event, selectedMarketObject, outcomeEntity)"
                                                    [isRacing]="outcomeEntity.isRacing"
                                                    [nonRunner]="outcomeEntity.nonRunner"
                                                    [handicapVal]="setSignsForHandicap(outcomeEntity.prices[0]?.handicapValueDec)"
                                                    [eventQuickSwitch]="eventQuickSwitch">
                                                </price-odds-button>
                                            }
                                        </div>
                                    }
                                    @if (isHomeDrawAwayType && !isFootball && !showTemplate(i) && !outcomeEntity) {
                                        <div class="odds-btn-wrapper" data-crlat="oddsBtnWrapper"></div>
                                    }
                                </div>
                            }
                        </div>
                    }

                    <div (click)="$event.stopPropagation()">
                        @if (!isOddsSports && market?.outcomes[0]) {
                            <price-odds-button
                                id="bet-{{ market.outcomes[0].id }}"
                                [event]="event"
                                [market]="selectedMarketObject"
                                [outcome]="market?.outcomes[0]"
                                [gtmModuleTitle]="gtmModuleTitle"
                                class="price-odds-button"
                                (click)="onPriceOddsButtonClick($event, event, market, market.outcomes[0])"
                                [isRacing]="market?.outcomes[0].isRacing"
                                [nonRunner]="market?.outcomes[0].nonRunner"
                                [eventQuickSwitch]="eventQuickSwitch">
                            </price-odds-button>
                        }
                    </div>
                </div>
            </div>
            <div class="odds-footer" data-crlat="oddsFooter">
                <div class="odds-left" data-crlat="oddsLeft">
                    @if (isFootball && !isFavouritesDisabled) {
                        <favourite-icon
                            [isActive]="isFavouriteActive"
                            [isOnMatch]="isMatchSortCode"
                            data-crlat="addFavouritesButton"
                            (click)="favouriteClickHandler($event)"></favourite-icon>
                    }
                    <!-- Live label -->
                    @if (isEventStartedOrLive && !isIP && !isHP) {
                        <div class="odds-live">
                            <svg class="odds-live-icon" data-crlat="liveLabel">
                                <use xlink:href="#live-icon"></use>
                            </svg>
                            <span [i18n]="'sb.live'"></span>
                        </div>
                    }
                    <!-- Stream icon -->
                    @if (isStream && !isIP && !isHP) {
                        <svg class="odds-icon-stream" data-crlat="oddsIconStream" [ngClass]="{ 'watch-live': isEventStartedOrLive }">
                            <use xlink:href="#stream"></use>
                        </svg>
                        @if (isEventStartedOrLive) {
                            <span class="odds-watch-live" [i18n]="'sb.watchLive'" data-crlat="watchLive"> </span>
                        } @else {
                            <span class="odds-watch" [i18n]="'sb.watch'"> </span>
                        }
                    }
                    @if (isStream && (isIP || isHP)) {
                        <svg class="odds-icon-stream odds-inplay-stream" data-crlat="oddsIconStream">
                            <use xlink:href="#stream"></use>
                        </svg>
                        @if (isEventStartedOrLive) {
                            <span class="odds-watch-live" [i18n]="'sb.watchLive'" data-crlat="watchLive"> </span>
                        } @else {
                            <span class="odds-watch" [ngClass]="isIP || isHP ? 'odds-watch-inplay' : ''" [i18n]="'sb.watch'"> </span>
                        }
                    }

                    <!-- Live clock -->
                    @if (isClockAllowed()) {
                        <live-clock data-crlat="liveClock" [event]="event" class="live-clock"> </live-clock>
                    }
                    <!-- Odds label for HT/FT or tennis set -->
                    @if (isLabelShown) {
                        <span [textContent]="oddsLabel" class="odds-label" data-crlat="oddsCardLabel"> </span>
                    }
                </div>

                <div class="odds-right" data-crlat="oddsRight">
                    <promotion-icon
                        class="odds-card-promotions-icon"
                        [event]="event"
                        [type]="'event'"
                        [display]="event.drilldownTagNames"
                        [typeId]="event.typeId"
                        [bwinId]="event.bwinId"
                        [eventId]="event.id"
                        [mode]="'sm'"
                        [isEventStartedOrLive]="isEventStartedOrLive"
                        [isIP]="isIP"
                        [isHP]="isHP"
                        [ngClass]="isIP || isHP ? 'pii' : ''"
                        data-crlat="promotionIcons">
                    </promotion-icon>
                    @if (market.nextScore) {
                        <span class="odds-next-score" [textContent]="market?.nextScore | callBack: addOrdinalSuffix : this + ' Goal'"></span>
                    }
                    @if (showMarketsCount) {
                        <a
                            class="odds-more-link"
                            [ngClass]="{ inplayMore: isIP }"
                            linkHref
                            [link]="goToEvent(true)"
                            [textContent]="event.marketsCount | eventMore: isIP : isHP"
                            data-crlat="marketsCount"></a>
                    }
                    @if (market.isSmartBoosts && wasPrice) {
                        <div class="was-price">
                            <span [i18n]="'sb.wasPrice'"></span>
                            <strike [textContent]="wasPrice"></strike>
                        </div>
                    }
                </div>
            </div>
        </div>
    }
}
